import { render, staticRenderFns } from "./CustomerUrlComponent.vue?vue&type=template&id=3c903b24&scoped=true&"
import script from "./CustomerUrlComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerUrlComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomerUrlComponent.vue?vue&type=style&index=0&id=3c903b24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c903b24",
  null
  
)

export default component.exports